/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from '../../services/account.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  standalone: false,
})
export class ForgotPasswordComponent {
  email: string;
  error: string;

  constructor(
    private accountService: AccountService,
    public activeModal: NgbActiveModal,
  ) {}

  async sendRequest(f: NgForm) {
    this.error = '';
    this.error = await this.accountService.forgotPassword(f.value.email);
    if (this.error) {
      f.form.get('email')?.setErrors({ customerror: true });
    }
  }
}
